import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, OnInit, forwardRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/pages/auth';
import { AddressService } from 'src/app/services/api/address.service';
import { Address } from 'src/app/services/model/address.model';
import { ToastService } from 'src/app/services/toast-service/toast.service';
import { SharedModule } from 'src/shared/shared.module';
import { LabelMode } from 'src/utils/label-mode.enum';

@Component({
  selector: 'app-form',
  imports: [CommonModule,
    forwardRef(() => SharedModule),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent implements OnInit {
  #fb = inject(FormBuilder);
  #cdr = inject(ChangeDetectorRef);
  #authService = inject(AuthService);
  #addressService = inject(AddressService);
  #toastService = inject(ToastService);

  @Input() set getterForm(value: FormGroup) {
    if (value) {
      this.form = value
    } else {
      this.buildForm();
    }
  }
  @Input() set getterError(value: any) {
    this.error = value
  }
  @Input() set data(value: Address | null) {
    if (!this.form) {
      this.buildForm();
    }
    if (value) {
      this.patchForm(value);
    }
  }

  @Input() form: FormGroup;
  @Input() selectAppendTo: string | null = 'body';




  // form: FormGroup;
  LabelMode = LabelMode;
  error: any;

  ngOnInit(): void {
    console.log('sel', this.selectAppendTo);

  }

  buildForm() {
    this.form = this.#fb.group({
      id: [null],
      name: [null, Validators.required],
      address: [null, Validators.required],
      province_id: [null, Validators.required],
      district_id: [null, Validators.required],
      sub_district_id: [null, Validators.required],
      post_code: [null, Validators.required],
    });
    this.form
      .get("province_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((val) => {
        this.form.patchValue({ district_id: null });
      });
    this.form
      .get("district_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((val) => {
        if (!val) {
          this.form.patchValue({ sub_district_id: null });
        }
      });
    this.form
      .get("sub_district_id")
      ?.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
      .subscribe(async (val) => {
        if (val) {
          const sub_dist = await lastValueFrom(
            this.#addressService.getSubDistrict(val),
          );
          this.form.patchValue({ post_code: sub_dist.post_code });
        } else {
          this.form.patchValue({ post_code: null });
        }
      });
  }

  patchForm(value: Address) {
    setTimeout(() => {
      this.form.patchValue(
        {
          ...value,
          province_id: value.province?.id,
          district_id: value.district?.id,
          sub_district_id: value.sub_district_id,
          post_code: value.sub_district?.post_code,
        },
        { emitEvent: false },
      );
      this.#cdr.detectChanges();
    }, 500);
  }


}
